import { apiClient } from './api';
import {
  NicheAgentStartRequest,
  NicheAgentSession,
  NicheAgentIterateRequest,
  NicheAgentIterateResponse,
  NicheAgentBulkIterateRequest,
  NicheAgentBulkIterateResponse,
  NicheAgentCompactRequest,
  NicheAgentCompactResponse,
  NicheAgentMetadata
} from '../models/nicheAgents';

export class NicheAgentService {
  private endpoint: string;

  constructor(agentMetadata: NicheAgentMetadata) {
    this.endpoint = agentMetadata.endpoint;
  }

  async startSession(request: NicheAgentStartRequest): Promise<NicheAgentSession> {
    const response = await apiClient.post(`${this.endpoint}/session/start`, request);
    // Ensure iterations array exists
    return {
      ...response.data,
      iterations: response.data.iterations || []
    };
  }

  async getSession(sessionId: string): Promise<NicheAgentSession> {
    const response = await apiClient.get(`${this.endpoint}/session/${sessionId}`);
    // Ensure iterations array exists
    return {
      ...response.data,
      iterations: response.data.iterations || []
    };
  }

  async iterate(sessionId: string, request: NicheAgentIterateRequest): Promise<NicheAgentIterateResponse> {
    const response = await apiClient.post(`${this.endpoint}/session/${sessionId}/iterate`, request);
    return response.data;
  }

  async bulkIterate(sessionId: string, request: NicheAgentBulkIterateRequest): Promise<NicheAgentBulkIterateResponse> {
    const response = await apiClient.post(`${this.endpoint}/session/${sessionId}/bulk-iterate`, request);
    return response.data;
  }

  async compactPrompt(sessionId: string, request: NicheAgentCompactRequest): Promise<NicheAgentCompactResponse> {
    const response = await apiClient.post(`${this.endpoint}/session/${sessionId}/compact`, request);
    return response.data;
  }
}

export const createNicheAgentService = (agentMetadata: NicheAgentMetadata): NicheAgentService => {
  return new NicheAgentService(agentMetadata);
};